export default {"src":"/login-app/[GIT_HASH]/_next/static/media/warning_outline.65d4e8ec.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};